module.exports = __webpack_public_path__ + "img/foundersgarden-v-474x632.f3835245.jpg";